import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuccess = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 80 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M40.0004 80.0008C62.092 80.0008 80.0008 62.092 80.0008 40.0004C80.0008 17.9088 62.092 0 40.0004 0C17.9088 0 0 17.9088 0 40.0004C0 62.092 17.9088 80.0008 40.0004 80.0008Z",
		fill: "#3E94FF"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M62.4003 25.5777C46.8441 38.3359 32.5794 62.5858 32.5794 62.5858C26.8737 52.9571 17.6016 47.4854 17.6016 47.4854L23.0526 39.5022C28.0935 43.8551 32.4602 49.3908 32.4602 49.3908C40.0808 33.6946 53.5003 17.4141 53.5003 17.4141L62.4003 25.5768V25.5777Z",
		fill: "white"
	})]
});
export default SvgSuccess;
